import { useAppSelector } from '@state/redux/store';
import React, { useEffect } from 'react';
import type { User } from '../../@types/redux/users';

// Declare the Zendesk function on the global window object
declare global {
  interface Window {
    zE: (
      widget: string,
      action: string,
      options: Record<string, { value: string; readOnly: boolean }>
    ) => void;
  }
}

const ZendeskWidget: React.FC = () => {
  // Replace the following selector with the actual path to your user details in the builder slice.
  const user: User = useAppSelector((state) => state.users.user);

  useEffect(() => {
    // Wait until the Zendesk widget is loaded
    if (typeof window.zE === 'function') {
      if (user.attributes.email) {
        // If the user is logged in, prefill Zendesk fields
        const nameReadonly = user.attributes.name.length > 0 ? true : false;
        const emailReadonly = user.attributes.email.length > 0 ? true : false;
        window.zE('webWidget', 'prefill', {
          name: { value: user.attributes.name, readOnly: nameReadonly },
          email: { value: user.attributes.email, readOnly: emailReadonly },
        });
      } else {
        // If there is no user, clear Zendesk fields
        window.zE('webWidget', 'prefill', {
          name: { value: '', readOnly: false },
          email: { value: '', readOnly: false },
        });
      }
    }
  }, [user]);

  // This component doesn't render any visible output
  return null;
};

export default ZendeskWidget;
